export const PrivacyContent = () => (
  <div data-testid="privacy-content" className="space-y-6 text-sm leading-relaxed text-slate-600">
    <section>
      <h2 className="font-semibold text-slate-900">1. Verantwortlicher</h2>
      <p className="mt-2">
        Verantwortlich für die Datenverarbeitung auf dieser Website ist:
      </p>
      <p className="mt-2">
        Armin Damerow<br />
        WebDesign Damerow<br />
        Rosenthaler Straße 15<br />
        13127 Berlin<br />
        E-Mail: kontakt@webdesign-damerow.de
      </p>
    </section>

    <section>
      <h2 className="font-semibold text-slate-900">2. Bereitstellung der Website und Hosting</h2>
      <p className="mt-2">
        Diese Website wird bei Netlify, Inc., 101 2nd Street, San Francisco, CA 94105, USA, gehostet. Beim Aufruf verarbeitet Netlify technisch erforderliche Zugriffsdaten. Dazu können insbesondere IP-Adresse, Zeitpunkt des Zugriffs, aufgerufene Seite oder Datei, Browsertyp, Betriebssystem, Referrer-URL, übertragene Datenmenge und HTTP-Statuscode gehören.
      </p>
      <p className="mt-2">
        Die Verarbeitung dient der sicheren, stabilen und technisch fehlerfreien Bereitstellung der Website. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO. Das berechtigte Interesse liegt in der sicheren und zuverlässigen Bereitstellung des Webangebots.
      </p>
      <p className="mt-2">
        Netlify ist ein Unternehmen mit Sitz in den USA. Eine Verarbeitung außerhalb der Europäischen Union kann daher nicht ausgeschlossen werden. Netlify nennt hierfür insbesondere das EU-U.S. Data Privacy Framework und Standardvertragsklauseln als Übermittlungsmechanismen. Soweit Netlify personenbezogene Daten in unserem Auftrag verarbeitet, gelten die datenschutzrechtlichen Vertragsbedingungen einschließlich des Data Processing Addendum von Netlify.
      </p>
      <p className="mt-2">
        Weitere Informationen finden Sie in der{" "}
        <a href="https://www.netlify.com/privacy/" target="_blank" rel="noopener noreferrer" data-testid="privacy-netlify-link" className="text-[#2563EB] underline">
          Datenschutzerklärung von Netlify
        </a>.
      </p>
    </section>

    <section>
      <h2 className="font-semibold text-slate-900">3. Kontaktaufnahme per E-Mail</h2>
      <p className="mt-2">
        Wenn Sie per E-Mail Kontakt aufnehmen, werden die übermittelten Angaben zur Bearbeitung der Anfrage verarbeitet. Die E-Mail-Kommunikation erfolgt über ein bei IONOS geführtes Postfach.
      </p>
      <p className="mt-2">
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, soweit die Anfrage der Vorbereitung oder Durchführung eines Vertrags dient. In anderen Fällen beruht die Verarbeitung auf Art. 6 Abs. 1 lit. f DSGVO; das berechtigte Interesse liegt in der Bearbeitung der Kontaktanfrage.
      </p>
    </section>

    <section>
      <h2 className="font-semibold text-slate-900">4. Kontaktformular / kostenloser Website-Check</h2>
      <p className="mt-2">
        Für den Website-Check können Name, Unternehmen, Website-URL, E-Mail-Adresse sowie freiwillig eine Telefonnummer und Angaben zu Wünschen oder Anforderungen verarbeitet werden. Pflichtfelder sind im Formular als solche gekennzeichnet.
      </p>
      <p className="mt-2">
        Die Verarbeitung dient der Bearbeitung der Website-Check-Anfrage und gegebenenfalls der Vorbereitung eines möglichen Auftrags. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, wenn die Anfrage auf vorvertragliche Maßnahmen gerichtet ist. Bei allgemeinen Anfragen ist Art. 6 Abs. 1 lit. f DSGVO die Rechtsgrundlage; das berechtigte Interesse liegt in der sachgerechten Beantwortung der Anfrage.
      </p>
      <p className="mt-2">
        Das Formular wird technisch über Netlify Forms verarbeitet. Die Angaben werden per HTTPS an Netlify übertragen und im Netlify-Projekt als Formularübermittlung gespeichert. Netlify stellt die Übermittlung zur Bearbeitung bereit und kann eine Benachrichtigung an das Postfach kontakt@webdesign-damerow.de auslösen. Das Postfach wird bei IONOS geführt. Eine Übermittlung an ein eigenes FastAPI- oder MongoDB-System findet auf der veröffentlichten Website für dieses Formular nicht statt.
      </p>
      <p className="mt-2">
        Eine feste automatische Löschfrist ist im Website-Code nicht hinterlegt. Formulareingänge werden in Netlify gespeichert, bis sie dort gelöscht werden. Sie werden gelöscht, sobald sie für die Bearbeitung und eine mögliche Vertragsabwicklung nicht mehr erforderlich sind und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
      </p>
      <p className="mt-2">
        Netlify wird für Hosting und Formularverarbeitung als technischer Dienstleister eingesetzt. Die Hinweise zur Auftragsverarbeitung und zu möglichen Übermittlungen in die USA im Hostingabschnitt gelten daher auch für das Formular.
      </p>
    </section>

    <section>
      <h2 className="font-semibold text-slate-900">5. Cookies, Schriften und externe Dienste</h2>
      <p className="mt-2">
        Die Website setzt im eigenen Anwendungscode keine Analyse-, Tracking- oder Marketingdienste ein und verwendet keine nicht technisch notwendigen Cookies. Es sind keine Tracking-Pixel, Karten-, Video- oder Social-Media-Einbettungen aktiv. Die verwendeten Schriften werden lokal von der Website ausgeliefert; beim Seitenaufruf wird keine Verbindung zu Google Fonts hergestellt.
      </p>
      <p className="mt-2">
        Deshalb ist derzeit kein Einwilligungsbanner für Cookies oder externe Marketingdienste erforderlich. Sollte sich die eingesetzte Technik ändern, wird diese Datenschutzerklärung entsprechend angepasst und eine erforderliche Einwilligung vorab eingeholt.
      </p>
    </section>

    <section>
      <h2 className="font-semibold text-slate-900">6. Externe Links</h2>
      <p className="mt-2">
        Externe Websites werden erst beim Anklicken eines entsprechenden Links aufgerufen. Für deren Inhalte und Datenverarbeitung ist der jeweilige Anbieter verantwortlich.
      </p>
    </section>

    <section>
      <h2 className="font-semibold text-slate-900">7. Speicherdauer</h2>
      <p className="mt-2">
        Personenbezogene Daten werden nur so lange gespeichert, wie dies für den jeweiligen Zweck erforderlich ist. Gesetzliche Aufbewahrungspflichten bleiben unberührt. Die konkrete Speicherdauer kann sich daher nach dem Verlauf der Anfrage und einer möglichen Geschäftsbeziehung richten.
      </p>
    </section>

    <section>
      <h2 className="font-semibold text-slate-900">8. Ihre Rechte</h2>
      <p className="mt-2">Im Rahmen der gesetzlichen Voraussetzungen bestehen insbesondere Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch. Eine erteilte Einwilligung kann jederzeit für die Zukunft widerrufen werden. Außerdem besteht ein Beschwerderecht bei einer Datenschutzaufsichtsbehörde.</p>
    </section>

    <section>
      <h2 className="font-semibold text-slate-900">9. Zuständige Aufsichtsbehörde</h2>
      <p className="mt-2">
        Berliner Beauftragte für Datenschutz und Informationsfreiheit<br />
        Alt-Moabit 59–61<br />
        10555 Berlin
      </p>
    </section>

    <section>
      <h2 className="font-semibold text-slate-900">10. Stand</h2>
      <p className="mt-2">Stand: September 2026</p>
    </section>
  </div>
);